import { gql, TypedDocumentNode } from '@apollo/client';

export type BraintreeClientTokenQuery = {
  braintreeClientToken: {
    __typename: 'RestBraintreeClientToken';
    token: string;
  };
};

export const BRAINTREE_CLIENT_TOKEN_QUERY: TypedDocumentNode<BraintreeClientTokenQuery> = gql`
  query BraintreeClientTokenQuery {
    braintreeClientToken
      @rest(
        type: "RestBraintreeClientToken"
        endpoint: "moda"
        path: "/v3.5/payments/bt_client_token"
      ) {
      token
    }
  }
`;
